import { ReactElement } from 'react';
import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SupportResult } from 'types/domainTypes';
import { TableRow } from 'components/atoms/TableRow';

interface Props {
  supportReaction: SupportResult;
  showFasteners: boolean;
}

export function SupportReactionResultsRow({ supportReaction, showFasteners }: Props): ReactElement {
  const { t, i18n } = useTranslation();
  const { supportNumber, minReaction, numberOfFasteners } = supportReaction;

  return (
    <TableRow>
      <TableCell component="th" scope="row" data-testid={`support${supportNumber}`}>
        {`${t('calculation-page.results-panel.minimum-reaction.label-support')} ${supportNumber}`}
      </TableCell>
      <TableCell align="left" data-testid={`minReaction${supportNumber}`}>
        {minReaction.toLocaleString(i18n.language, { maximumFractionDigits: 3, minimumFractionDigits: 0 })}
      </TableCell>
      {showFasteners && (
        <TableCell align="left" data-testid={`numberOfFasteners${supportNumber}`}>
          {numberOfFasteners}
        </TableCell>
      )}
    </TableRow>
  );
}
